import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PushProvider } from '../../providers/push/push'
import { Storage } from '@ionic/storage'

@IonicPage()
@Component({
  selector: 'page-push',
  templateUrl: 'push.html',
})
export class PushPage {
  datosPush:any[] = []
  constructor(public navCtrl: NavController, public navParams: NavParams,public servicio:PushProvider,
              public storages:Storage) {

  }

  ionViewDidLoad() {
    this.buscar()
  }
  buscar(){
    this.storages.get('companiasId').then((val)=>{
      this.servicio.buscar(val)
    .subscribe((data)=>{
      this.datosPush = data.data[0]
      if(this.datosPush.length<=0){
            this.datosPush = [
      {  "modulo":"Advertencia","id":1,"mensaje":"No tiene notificaciones","src":"https://res.cloudinary.com/drqk6qzo7/image/upload/v1539203779/advertencia_w7uxp6.png"}
     ]
      }
    },(error)=>{
      console.log(error)
    })
    })

  }
  ir(){
    this.navCtrl.pop();
  }

  eliminarRegistro(item,i){
    let id = Number(item.pushId)
      this.servicio.eliminar(id)
      .subscribe((data)=>{
       this.datosPush.splice(i,1)
       if(this.datosPush.length<=0){
         this.navCtrl.pop()
       }
      },(error)=>{
        console.log(error)
      })
  }


}



// WEBPACK FOOTER //
// ./src/pages/push/push.ts